__turbopack_context__.v({
  "loadingContainer": "LoaderOverlay-module-scss-module__zYMimG__loadingContainer",
  "spin": "LoaderOverlay-module-scss-module__zYMimG__spin",
  "spinner": "LoaderOverlay-module-scss-module__zYMimG__spinner",
});
